import { ItemsInventoryStore } from '../../../store/ItemsInventoryStore';
import { PRODUCT_TYPE } from '~/types/product';

export const itemsInventoryMealStore = new ItemsInventoryStore(PRODUCT_TYPE.MEAL_COMBO);
